export default __webpack_public_path__ + "static/media/footer-Logo.2f6396b9.png";